import { EmailEventStatus } from "@/gql/graphql";

const failureStatuses: EmailEventStatus[] = [
  EmailEventStatus.PermanentFail,
  EmailEventStatus.TemporaryFail,
  EmailEventStatus.Rejected,
  EmailEventStatus.Complained,
];

export function isFailedEmailStatus(status: EmailEventStatus): boolean {
  return failureStatuses.includes(status);
}
